<template>
  <div class="ace-paper-cont clear-mrg">

    <!-- START: PAGE CONTENT -->

    <div class="padd-box">
      <h1 class="title-lg text-upper">游览</h1>
    </div>


    <div id="pf-wrap" class="pf-wrap">
      <div class="pf-filter padd-box">
        <button data-filter="*">全部</button>
        <button data-filter=".photography">杭州</button>
        <button data-filter=".design">郑州</button>
      </div>

      <div id="pf-grid" class="pf-grid">
        <div class="pf-grid-sizer"></div><!-- used for sizing -->

        <div class="pf-grid-item photography">
          <div class="project">
            <figure class="portfolio-figure">
              <img src="/static/img/uploads/portfolio/prj-01.jpg" alt="">
            </figure>

            <div class="portfolio-caption text-center">
              <div class="valign-table">
                <div class="valign-cell">
                  <h2 class="text-upper">stu unger rise</h2>
                  <p>Accessories Here you can find the best computer monitor,
                    printer, scanner, speaker, projector. hardware and more
                  </p>
                  <a href="#pf-popup-1" class="pf-btn-view btn btn-primary">View More</a>
                </div>
              </div>
            </div>
          </div>

          <div id="pf-popup-1" class="pf-popup clearfix">
            <div class="pf-popup-col1">
              <div class="pf-popup-media">

              </div>
            </div><!-- .pf-popup-col1 -->

            <div class="pf-popup-col2">
              <div class="pf-popup-info clear-mrg">
                <h2 class="text-upper">Project Title</h2>
                <p class="text-muted"><strong>design / development</strong></p>
                <dl class="dl-horizontal">
                  <dt>Date:</dt>
                  <dd>11 Jan 2012</dd>

                  <dt>Site link:</dt>
                  <dd><a href="www.sitedomen.com">www.sitedomen.com</a></dd>

                  <dt>Client:</dt>
                  <dd>11 Jan 2012</dd>
                </dl>
                <p>About 64% of all on-line teens say that do things online that
                  they wouldn’t want their
                  parents to know about. 11% of all adult internet users visit
                  dating websites and spend their
                  time in chatrooms. Some of the classify their behavior as
                  “cyber affair” More then 60% of
                  employees use company PC for the personal needs during their
                  work hours as long as 80
                  minutes per day. </p>
              </div><!-- .pf-popup-info -->

            </div><!-- .pf-popup-col2 -->
          </div><!-- .pf-popup -->
        </div><!-- .pf-grid-item -->

        <div class="pf-grid-item design">
          <div class="project">
            <figure class="portfolio-figure">
              <img src="/static/img/uploads/portfolio/prj-02.jpg" alt="">
            </figure>

            <div class="portfolio-caption text-center">
              <div class="valign-table">
                <div class="valign-cell">
                  <h2 class="text-upper">stu unger rise</h2>
                  <p>Accessories Here you can find the best computer monitor,
                    printer, scanner, speaker, projector. hardware and more
                  </p>
                  <a href="#pf-popup-2" class="pf-btn-view btn btn-primary">View More</a>
                </div>
              </div>
            </div>
          </div>

          <div id="pf-popup-2" class="pf-popup clearfix">
            <div class="pf-popup-col1">
              <div class="pf-popup-media">

              </div>
            </div><!-- .pf-popup-col1 -->

            <div class="pf-popup-col2">
              <div class="pf-popup-info clear-mrg">
                <h2 class="text-upper">Project Title</h2>
                <p class="text-muted"><strong>design / development</strong></p>
                <dl class="dl-horizontal">
                  <dt>Date:</dt>
                  <dd>11 Jan 2012</dd>

                  <dt>Site link:</dt>
                  <dd><a href="www.sitedomen.com">www.sitedomen.com</a></dd>

                  <dt>Client:</dt>
                  <dd>11 Jan 2012</dd>
                </dl>
                <p>About 64% of all on-line teens say that do things online that
                  they wouldn’t want their
                  parents to know about. 11% of all adult internet users visit
                  dating websites and spend their
                  time in chatrooms. Some of the classify their behavior as
                  “cyber affair” More then 60% of
                  employees use company PC for the personal needs during their
                  work hours as long as 80
                  minutes per day. </p>
              </div><!-- .pf-popup-info -->

            </div><!-- .pf-popup-col2 -->
          </div><!-- .pf-popup -->
        </div><!-- .pf-grid-item -->

        <div class="pf-grid-item photography">
          <div class="project">
            <figure class="portfolio-figure">
              <img src="/static/img/uploads/portfolio/prj-03.jpg" alt="">
            </figure>

            <div class="portfolio-caption text-center">
              <div class="valign-table">
                <div class="valign-cell">
                  <h2 class="text-upper">stu unger rise</h2>
                  <p>Accessories Here you can find the best computer monitor,
                    printer, scanner, speaker, projector. hardware and more
                  </p>
                  <a href="#pf-popup-1" class="pf-btn-view btn btn-primary">View More</a>
                </div>
              </div>
            </div>
          </div>

          <div id="pf-popup-3" class="pf-popup clearfix">
            <div class="pf-popup-col1">
              <div class="pf-popup-media">

              </div>
            </div><!-- .pf-popup-col1 -->

            <div class="pf-popup-col2">
              <div class="pf-popup-info clear-mrg">
                <h2 class="text-upper">Project Title</h2>
                <p class="text-muted"><strong>design / development</strong></p>
                <dl class="dl-horizontal">
                  <dt>Date:</dt>
                  <dd>11 Jan 2012</dd>

                  <dt>Site link:</dt>
                  <dd><a href="www.sitedomen.com">www.sitedomen.com</a></dd>

                  <dt>Client:</dt>
                  <dd>11 Jan 2012</dd>
                </dl>
                <p>About 64% of all on-line teens say that do things online that
                  they wouldn’t want their
                  parents to know about. 11% of all adult internet users visit
                  dating websites and spend their
                  time in chatrooms. Some of the classify their behavior as
                  “cyber affair” More then 60% of
                  employees use company PC for the personal needs during their
                  work hours as long as 80
                  minutes per day. </p>
              </div><!-- .pf-popup-info -->

            </div><!-- .pf-popup-col2 -->
          </div><!-- .pf-popup -->
        </div><!-- .pf-grid-item -->

        <div class="pf-grid-item design">
          <div class="project">
            <figure class="portfolio-figure">
              <img src="/static/img/uploads/portfolio/prj-04.jpg" alt="">
            </figure>

            <div class="portfolio-caption text-center">
              <div class="valign-table">
                <div class="valign-cell">
                  <h2 class="text-upper">stu unger rise</h2>
                  <p>Accessories Here you can find the best computer monitor,
                    printer, scanner, speaker, projector. hardware and more
                  </p>
                  <a href="#pf-popup-4" class="pf-btn-view btn btn-primary">View More</a>
                </div>
              </div>
            </div>
          </div>

          <div id="pf-popup-4" class="pf-popup clearfix">
            <div class="pf-popup-col1">
              <div class="pf-popup-media">

              </div>
            </div><!-- .pf-popup-col1 -->

            <div class="pf-popup-col2">
              <div class="pf-popup-info clear-mrg">
                <h2 class="text-upper">Project Title</h2>
                <p class="text-muted"><strong>design / development</strong></p>
                <dl class="dl-horizontal">
                  <dt>Date:</dt>
                  <dd>11 Jan 2012</dd>

                  <dt>Site link:</dt>
                  <dd><a href="www.sitedomen.com">www.sitedomen.com</a></dd>

                  <dt>Client:</dt>
                  <dd>11 Jan 2012</dd>
                </dl>
                <p>About 64% of all on-line teens say that do things online that
                  they wouldn’t want their
                  parents to know about. 11% of all adult internet users visit
                  dating websites and spend their
                  time in chatrooms. Some of the classify their behavior as
                  “cyber affair” More then 60% of
                  employees use company PC for the personal needs during their
                  work hours as long as 80
                  minutes per day. </p>
              </div><!-- .pf-popup-info -->

            </div><!-- .pf-popup-col2 -->
          </div><!-- .pf-popup -->
        </div><!-- .pf-grid-item -->

        <div class="pf-grid-item photography">
          <div class="project">
            <figure class="portfolio-figure">
              <img src="/static/img/uploads/portfolio/prj-05.jpg" alt="">
            </figure>

            <div class="portfolio-caption text-center">
              <div class="valign-table">
                <div class="valign-cell">
                  <h2 class="text-upper">stu unger rise</h2>
                  <p>Accessories Here you can find the best computer monitor,
                    printer, scanner, speaker, projector. hardware and more
                  </p>
                  <a href="#pf-popup-5" class="pf-btn-view btn btn-primary">View More</a>
                </div>
              </div>
            </div>
          </div>

          <div id="pf-popup-5" class="pf-popup clearfix">
            <div class="pf-popup-col1">
              <div class="pf-popup-media">

              </div>
            </div><!-- .pf-popup-col1 -->

            <div class="pf-popup-col2">
              <div class="pf-popup-info clear-mrg">
                <h2 class="text-upper">Project Title</h2>
                <p class="text-muted"><strong>design / development</strong></p>
                <dl class="dl-horizontal">
                  <dt>Date:</dt>
                  <dd>11 Jan 2012</dd>

                  <dt>Site link:</dt>
                  <dd><a href="www.sitedomen.com">www.sitedomen.com</a></dd>

                  <dt>Client:</dt>
                  <dd>11 Jan 2012</dd>
                </dl>
                <p>About 64% of all on-line teens say that do things online that
                  they wouldn’t want their
                  parents to know about. 11% of all adult internet users visit
                  dating websites and spend their
                  time in chatrooms. Some of the classify their behavior as
                  “cyber affair” More then 60% of
                  employees use company PC for the personal needs during their
                  work hours as long as 80
                  minutes per day. </p>
              </div><!-- .pf-popup-info -->

            </div><!-- .pf-popup-col2 -->
          </div><!-- .pf-popup -->
        </div><!-- .pf-grid-item -->

        <div class="pf-grid-item design">
          <div class="project">
            <figure class="portfolio-figure">
              <img src="/static/img/uploads/portfolio/prj-06.jpg" alt="">
            </figure>

            <div class="portfolio-caption text-center">
              <div class="valign-table">
                <div class="valign-cell">
                  <h2 class="text-upper">stu unger rise</h2>
                  <p>Accessories Here you can find the best computer monitor,
                    printer, scanner, speaker, projector. hardware and more
                  </p>
                  <a href="#pf-popup-6" class="pf-btn-view btn btn-primary">View More</a>
                </div>
              </div>
            </div>
          </div>

          <div id="pf-popup-6" class="pf-popup clearfix">
            <div class="pf-popup-col1">
              <div class="pf-popup-media">

              </div>
            </div><!-- .pf-popup-col1 -->

            <div class="pf-popup-col2">
              <div class="pf-popup-info clear-mrg">
                <h2 class="text-upper">Project Title</h2>
                <p class="text-muted"><strong>design / development</strong></p>
                <dl class="dl-horizontal">
                  <dt>Date:</dt>
                  <dd>11 Jan 2012</dd>

                  <dt>Site link:</dt>
                  <dd><a href="www.sitedomen.com">www.sitedomen.com</a></dd>

                  <dt>Client:</dt>
                  <dd>11 Jan 2012</dd>
                </dl>
                <p>About 64% of all on-line teens say that do things online that
                  they wouldn’t want their
                  parents to know about. 11% of all adult internet users visit
                  dating websites and spend their
                  time in chatrooms. Some of the classify their behavior as
                  “cyber affair” More then 60% of
                  employees use company PC for the personal needs during their
                  work hours as long as 80
                  minutes per day. </p>
              </div><!-- .pf-popup-info -->

            </div><!-- .pf-popup-col2 -->
          </div><!-- .pf-popup -->
        </div><!-- .pf-grid-item -->

        <div class="pf-grid-item photography">
          <div class="project">
            <figure class="portfolio-figure">
              <img src="/static/img/uploads/portfolio/prj-01.jpg" alt="">
            </figure>

            <div class="portfolio-caption text-center">
              <div class="valign-table">
                <div class="valign-cell">
                  <h2 class="text-upper">stu unger rise</h2>
                  <p>Accessories Here you can find the best computer monitor,
                    printer, scanner, speaker, projector. hardware and more
                  </p>
                  <a href="#pf-popup-7" class="pf-btn-view btn btn-primary">View More</a>
                </div>
              </div>
            </div>
          </div>

          <div id="pf-popup-7" class="pf-popup clearfix">
            <div class="pf-popup-col1">
              <div class="pf-popup-media">

              </div>
            </div><!-- .pf-popup-col1 -->

            <div class="pf-popup-col2">
              <div class="pf-popup-info clear-mrg">
                <h2 class="text-upper">Project Title</h2>
                <p class="text-muted"><strong>design / development</strong></p>
                <dl class="dl-horizontal">
                  <dt>Date:</dt>
                  <dd>11 Jan 2012</dd>

                  <dt>Site link:</dt>
                  <dd><a href="www.sitedomen.com">www.sitedomen.com</a></dd>

                  <dt>Client:</dt>
                  <dd>11 Jan 2012</dd>
                </dl>
                <p>About 64% of all on-line teens say that do things online that
                  they wouldn’t want their
                  parents to know about. 11% of all adult internet users visit
                  dating websites and spend their
                  time in chatrooms. Some of the classify their behavior as
                  “cyber affair” More then 60% of
                  employees use company PC for the personal needs during their
                  work hours as long as 80
                  minutes per day. </p>
              </div><!-- .pf-popup-info -->

            </div><!-- .pf-popup-col2 -->
          </div><!-- .pf-popup -->
        </div><!-- .pf-grid-item -->
      </div><!-- .pf-grid -->
    </div><!-- .pf-wrap -->

    <!-- END: PAGE CONTENT -->

  </div><!-- .ace-paper-cont -->

</template>

<script>
  export default {
    name: 'portfolio',
    data() {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    },
    mounted: function() {

      var that = this;
      this.$nextTick(() => {
          setTimeout(function() {
            var pf_grid = $('.pf-grid');
            if (pf_grid.length > 0) {

              // Isotope Initialization
              var grid = pf_grid.isotope({
                isOriginLeft: !aceOptions.rtl,
                itemSelector: '.pf-grid-item',
                percentPosition: true,
                masonry: {
                  columnWidth: '.pf-grid-sizer'
                }
              });

              var filter = $('.pf-filter');
              if (filter.length > 0) {
                var filter_btn = filter.find('button');
                var filter_btn_first = $('.pf-filter button:first-child');

                filter_btn_first.addClass('active');

                filter_btn.on('click', function() {
                  filter_btn.removeClass('active');
                  $(this).addClass('active');

                  var filterValue = $(this).attr('data-filter');
                  grid.isotope({
                    filter: filterValue
                  });
                });
              }

              pf_grid.addClass('loaded');
            }
          }, 50);
        })
      }
    }
</script>



// WEBPACK FOOTER //
// src/components/portfolio.vue